import { css } from 'styled-components';
import { themeColor } from './colors';

export const ellipsisMixin = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const clickableMixin = css`
  user-select: none;
  cursor: pointer;
`;

export const transitionFunc = 'cubic-bezier(0.165, 0.84, 0.44, 1)';

export const rainboxTextMixin = css`
  background: ${themeColor('nodeTextRainbow')};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
